export default "__VITE_ASSET__2hayr1Eq__"